function _define_property(obj, key, value) {
    if (key in obj) {
        Object.defineProperty(obj, key, {
            value: value,
            enumerable: true,
            configurable: true,
            writable: true
        });
    } else {
        obj[key] = value;
    }
    return obj;
}
function _extends() {
    _extends = Object.assign || function(target) {
        for(var i = 1; i < arguments.length; i++){
            var source = arguments[i];
            for(var key in source){
                if (Object.prototype.hasOwnProperty.call(source, key)) {
                    target[key] = source[key];
                }
            }
        }
        return target;
    };
    return _extends.apply(this, arguments);
}
function _object_spread(target) {
    for(var i = 1; i < arguments.length; i++){
        var source = arguments[i] != null ? arguments[i] : {};
        var ownKeys = Object.keys(source);
        if (typeof Object.getOwnPropertySymbols === "function") {
            ownKeys = ownKeys.concat(Object.getOwnPropertySymbols(source).filter(function(sym) {
                return Object.getOwnPropertyDescriptor(source, sym).enumerable;
            }));
        }
        ownKeys.forEach(function(key) {
            _define_property(target, key, source[key]);
        });
    }
    return target;
}
import { jsx as _jsx } from "react/jsx-runtime";
import { CircleCheckIcon, InfoIcon, Loader2Icon, OctagonXIcon, TriangleAlertIcon } from 'lucide-react';
import { Toaster as Sonner } from 'sonner';
const Toaster = (_0)=>{
    let {} = _0, props = _extends({}, _0);
    return /*#__PURE__*/ _jsx(Sonner, _object_spread({
        // theme={"light" as ToasterProps["theme"]}
        className: "toaster group",
        richColors: true,
        icons: {
            success: /*#__PURE__*/ _jsx(CircleCheckIcon, {
                className: "size-4"
            }),
            info: /*#__PURE__*/ _jsx(InfoIcon, {
                className: "size-4"
            }),
            warning: /*#__PURE__*/ _jsx(TriangleAlertIcon, {
                className: "size-4"
            }),
            error: /*#__PURE__*/ _jsx(OctagonXIcon, {
                className: "size-4"
            }),
            loading: /*#__PURE__*/ _jsx(Loader2Icon, {
                className: "size-4 animate-spin"
            })
        }
    }, props));
};
export { Toaster };
